import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { TranslateService } from '@ngx-translate/core';

import { ViGuideChangeLog } from '../../@store/updates/changelog.model';
import { MediaModalComponent } from '../media-modal/media-modal.component';

@Component({
  selector: 'app-viguide-update',
  templateUrl: './viguide-update.component.html',
  styleUrls: ['./viguide-update.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ViGuideUpdateComponent implements OnInit {
  @Input() update: ViGuideChangeLog;
  public improvements: { title: string; description?: string; mediaUrl?: string }[] = [];
  public fixes: string[] = [];
  mediaModalRef: MatDialogRef<MediaModalComponent>;

  constructor(private translate: TranslateService, private dialog: MatDialog) {}

  ngOnInit(): void {
    if (this.update) {
      if (this.update.improvements) {
        const changeLogImprovements: string[] = this.translate
          .instant(this.update.improvements)
          .split('#')
          .filter((update) => update);

        changeLogImprovements.forEach((improvement) => {
          //title:description:media
          const [title, description, mediaUrl]: string[] = improvement.split(': ');

          this.improvements.push({ title, description, mediaUrl });
        });
      }

      if (this.update.fixes) {
        this.fixes = this.translate
          .instant(this.update.fixes)
          .split('#')
          .filter((update) => update);
      }
    }
  }

  showMediaModal(data: { title: string; description?: string; mediaUrl?: string }): void {
    this.mediaModalRef = this.dialog.open(MediaModalComponent, {
      width: '535px',
      data,
    });
  }

  isImage(src: string): boolean {
    const isImage = src.includes('jpg') || src.includes('png');

    return isImage;
  }
}
